import { Button } from "@/components/ui/button";
import { AUTH_ERROR_MESSAGES } from "@/utils/authErrors";
import { AlertCircle, LogIn } from "lucide-react";

interface AuthenticationErrorProps {
  title?: string;
  message?: string;
  showLoginButton?: boolean;
  onLoginClick?: () => void;
  icon?: React.ReactNode;
}

export const AuthenticationError = ({
  title = "ログインが必要です",
  message = AUTH_ERROR_MESSAGES.LOGIN_REQUIRED,
  showLoginButton = false,
  onLoginClick,
  icon
}: AuthenticationErrorProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="mb-4 text-gray-400">{icon || <AlertCircle className="h-12 w-12" />}</div>
      <h3 className="mb-2 text-lg font-semibold text-gray-900">{title}</h3>
      <p className="mb-4 max-w-md text-gray-600">{message}</p>
      <p className="mb-6 text-sm text-gray-500">問題が続く場合は管理者にお問い合わせください。</p>
      {showLoginButton && onLoginClick && (
        <Button onClick={onLoginClick} className="flex items-center gap-2">
          <LogIn className="h-4 w-4" />
          ログイン
        </Button>
      )}
    </div>
  );
};
